import { Stack, Button, Group, TextInput, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { UseMutationResult } from "@tanstack/react-query"
import { EditObjectField } from "../types"
import { DefaultModal } from "@components/default-modal"

interface EditObjectFieldsModalProps {
  opened: boolean
  onClose: () => void
  editObjectFields: EditObjectField[]
  setEditObjectFields: (fields: EditObjectField[]) => void
  updateObjectFieldsMutation: UseMutationResult<any, Error, EditObjectField[]>
}

export function EditObjectFieldsModal({
  opened,
  onClose,
  editObjectFields,
  setEditObjectFields,
  updateObjectFieldsMutation,
}: EditObjectFieldsModalProps) {
  const { t } = useTranslation("app_server")

  return (
    <DefaultModal
      opened={opened}
      onClose={() => {
        onClose()
        updateObjectFieldsMutation.reset()
      }}
      title={t("ObjectProperties")}
    >
      {opened && (
        <Stack gap="md">
          {editObjectFields.map((field, i) => (
            <TextInput
              key={i}
              label={field.type?.name ?? t("Field")}
              value={field.textValue ?? ""}
              onChange={(e) => {
                const updatedFields = [...editObjectFields]
                updatedFields[i].textValue = e.currentTarget.value
                setEditObjectFields(updatedFields)
              }}
            />
          ))}

          {updateObjectFieldsMutation.error && (
            <Text color="red" size="sm">
              {(updateObjectFieldsMutation.error as Error).message}
            </Text>
          )}

          <Group justify="flex-end" gap="md">
            <Button variant="default" onClick={onClose}>
              {t("Cancel")}
            </Button>
            <Button
              onClick={() =>
                updateObjectFieldsMutation.mutate(editObjectFields)
              }
              loading={updateObjectFieldsMutation.isPending}
            >
              {t("Save")}
            </Button>
          </Group>
        </Stack>
      )}
    </DefaultModal>
  )
}
